export default () => {
  return {
    content: {
      minWidht: '300px',
      padding: '20px',
    },
  };
};
